import React from 'react'
import createjs from 'preload-js'

class LoadProgressContainer extends React.Component{
  constructor(props){
    super(props)
    this.loadProgress = []
    this.state = {
      initialState: 0
    }
    this.hasLoaded = false
  }

  shouldComponentUpdate(){
    return !this.hasLoaded
  }

  componentDidMount(){
    this.currentScene = 0
    this.numberOfScenes = this.props.data.length
    this.preloadScenes(this.props.data)
  }

  preloadScenes(scenes){
    this.loadScene(scenes[0])
  }

  loadScene(scene){
    const url = scene.path + '/' + scene.name + '.json'
    fetch(url)
    .then(res => res.json())
    .then((out) => {
      const fileNames = this.extractFileNames(out);
      this.preloadScene(fileNames)
    })
    .catch(err => { throw err });
  }

  preloadScene(fileNames){
     var queue = new createjs.LoadQueue();
     queue.on("complete", this.handleSceneLoaded, this);
     queue.on("progress", this.handleSceneProgress, this);
     queue.loadManifest(fileNames)
  }

  handleSceneProgress(event){
    const divisor = 100 / this.numberOfScenes
    const sceneBase = (this.currentScene / this.numberOfScenes) * 100
    this.loadProgress[this.currentScene] = event.loaded
    const percentage = sceneBase + (event.loaded * divisor)
    this.updateProgressChange(percentage)
  }
  // LoadProgress
  // scenes array with percents
  handleSceneLoaded(scene){
    this.loadProgress[this.currentScene] = 1
    this.currentScene++
    const percentage = (this.currentScene / this.numberOfScenes) * 100
    this.updateProgressChange(percentage)
    if(this.currentScene !== this.numberOfScenes){
      this.loadScene(this.props.data[this.currentScene])
    } else {
      this.handleLoadComplete()
    }
  }

  updateProgressChange(percentage){
    this.props.loadChangeHandler({
      percentage: percentage,
      loadProgress: this.loadProgress
    })
    this.setState({percentage: percentage, scene: this.currentScene})
  }

  handleLoadComplete(){
    this.hasLoaded = true
    this.props.loadCompleteHandler()
  }

  extractFileNames(str){
    let count = 0
    const fileNames = []
    const assets = str.assets
    assets.forEach(function(data){
      if(data.p){
        fileNames.push({id: "image" + count, src: 'images/' + data.p})
        count++
      }
    })
    return {manifest: fileNames}
  }
  render(){
    const transition = 'opacity 3s ease-in-out'
    const style = {
      'position': 'fixed',
      'width': '100%',
      'height': '5px',
      'backgroundColor': 'rgba(255, 255, 255, 0.5)',
      'border': '1px solid rgba(255, 255, 255, 0.5)',
      'WebkitTransition': transition,
      'MozTransition': transition,
      'MsTransition': transition,
      'OTransition': transition,
      'opacity': (this.state.percentage === 100) ? '0' : '1',
      'zIndex': '100',
    }
    const innerStyle = {
      'width': this.state.percentage + "%",
      'height': '3px',
      'backgroundColor': 'rgba(88, 43, 130, 0.5)',
    }
    return(
      <div style={style} className="center">
        <div style={innerStyle}></div>
      </div>
    )
  }
}
export default LoadProgressContainer



// WEBPACK FOOTER //
// ./src/LoadProgressContainer.js